import React, { Fragment } from "react";
import { PageHero } from "../components/Global/PageHero";
import { BirthdayLookup } from "../components/Birthday/BirthdayLookup";
import { BackToTop } from "../templates/BackToTop";

export const Birthdays = () => (
  <Fragment>
    <PageHero
      eyebrow="Celebrate With Us"
      title="Find Your"
      highlight="Birthday Card"
      subtitle="Enter your surname and the last 4 digits of your phone number to view your personalised birthday card."
    />
    <BirthdayLookup />
    <BackToTop />
  </Fragment>
);
